import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import config from 'config'
import { hasGates } from 'utils/access'

interface SkillType {
  name: string
  gates?: string[]
}

export const useSkillData = () => {
  const { data: skillTypesData = {} } = useQuery<SkillType>({
    queryKey: ['static-skill-type-data'],
    queryFn: () =>
      fetch(`${config.FE_STATIC_DATA}/api/SkillTypesData`).then((response) =>
        response.json()
      ),
    staleTime: 60000,
  })

  const skillTypeOptions = useMemo(() => {
    return Object.entries<SkillType>(skillTypesData)
      .filter(([_, skill]) => {
        return !skill.gates || skill.gates.some((gate) => hasGates(gate))
      })
      .map(([key, skill]) => {
        return {
          label: skill.name,
          value: key,
        }
      })
  }, [skillTypesData])

  return { skillTypeOptions }
}

export default useSkillData
